import { IResponseError } from '@lib/error'

export enum AudienceInsightsActionTypes {
  FETCH_REQUEST = 'audienceInsights/FETCH_REQUEST',
  FETCH_SUCCESS = 'audienceInsights/FETCH_SUCCESS',
  FETCH_ERROR = 'audienceInsights/FETCH_ERROR',
  BRAND_CONNECT_FETCH_SUCCESS = 'audienceInsights/BRAND_CONNECT_FETCH_SUCCESS',
  APPLY_FILTERS = 'audienceInsights/APPLY_FILTERS',
}

interface IAudienceInsight {
  label: string
  value: number
  percentage: number
}

export interface IBrandConnectAudienceInterestInsight extends IAudienceInsight {
  relative_relevance: number
}

export interface IAudienceInsights {
  gender: IAudienceInsight[]
  age_range: ReadonlyArray<IAudienceInsight>
  top_countries: ReadonlyArray<IAudienceInsight>
  top_cities: ReadonlyArray<IAudienceInsight>
}

export interface IBrandConnectAudienceInsight {
  identity_id: number
  period?: string
  content_type?: string
  traffic_source?: string
  age_range: ReadonlyArray<IAudienceInsight>
  gender: ReadonlyArray<IAudienceInsight>
  top_countries: ReadonlyArray<IAudienceInsight>
  top_cities?: ReadonlyArray<IAudienceInsight>
  shopping_interests?: ReadonlyArray<IBrandConnectAudienceInterestInsight>
  watch_interests?: ReadonlyArray<IBrandConnectAudienceInterestInsight>
  affinity_interests?: ReadonlyArray<IBrandConnectAudienceInterestInsight>
  in_market_interests?: ReadonlyArray<IBrandConnectAudienceInterestInsight>
}

export interface IIAudienceInsightsState {
  readonly audienceInsightsByIdentityId: Record<number, IAudienceInsights>
  readonly brandConnectAudienceInsightsById: Record<
    number,
    ReadonlyArray<IBrandConnectAudienceInsight>
  >
  readonly filters: Record<string, string>
  readonly isFetching: boolean
  readonly errors?: IResponseError
}
